import { selectPaginationPages } from 'features/layout/features/pagination/paginationSlice';
import { useAppSelector } from 'store/hooks';
import { useMemo } from 'react';

export const usePaginationControls = () => {
  const { page, numPages } = useAppSelector(selectPaginationPages);

  return useMemo(() => [page !== numPages, page !== 1], [page, numPages]);
};
